import { Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import useEditorParams from '../../../newEditor/hook/params';
import useEditor from '../../../newEditor/hook/editor';
import EditorContainer from '../../../newEditor/editorContainer';
import { CatCommandPanel } from '../../../newEditor/commandPanels';
import { DocumentBody, Footer } from '../../../../components/Containers/docs';
import HidableContainer from '../../../documents/common/hidableContainer';
import { EditorControls, editorHooks } from '../../../basicEditor/editorControls';
import meta from '../../../../meta';

const { backendURL } = meta.cat.executive;

function Editor({
  onSave, onClose, id,
}) {
  const editorParams = useEditorParams();
  const {
    data, actions, fields, fieldErrors, nonFieldErrors, options, isNew, changed, permissions,
    loading, systemErrors, headerReadOnlyFields, printForms, headerProps,
  } = useEditor({
    backendURL,
    id,
    onCloseCallBack: onClose,
    onSaveCallBack: onSave,
    ...editorParams,
  });

  const firstNameProps = editorHooks.useStringInputProps('first_name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const lastLameProps = editorHooks.useStringInputProps('last_name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const additionalPhoneNumberProps = editorHooks.useStringInputProps('additional_phone_number', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const basisProps = editorHooks.useStringInputProps('basis', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const emailProps = editorHooks.useStringInputProps('email', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const phoneNumberProps = editorHooks.useStringInputProps('phone_number', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const rankProps = editorHooks.useStringInputProps('rank', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  return (
    <EditorContainer
      isNew={isNew}
      name={options.name}
      repr={data.repr}
      isLoading={loading}
      err={systemErrors}
      nonFieldErrors={nonFieldErrors}
      onClearNonFieldErrors={actions.onClearNonFieldErrors}
      onClearErrors={actions.onClearErrs}
      onClose={actions.onClose}
      changed={changed}
      fields={fields}
      CommandPanel={(
        <CatCommandPanel
          backendURL={backendURL}
          permissions={permissions}
          actions={actions}
          changed={changed}
          executed={data.executed}
          printForms={printForms}
          id={id}
          repr={data.repr}
        />
      )}
    >
      <DocumentBody>
        <HidableContainer>
          <Container fluid style={{ padding: '0' }}>
            <Row>
              <Col>
                <EditorControls.StringInput {...firstNameProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...lastLameProps} />
              </Col>
            </Row>
            <Row>
              <Col>
                <EditorControls.StringInput {...phoneNumberProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...additionalPhoneNumberProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...emailProps} />
              </Col>
            </Row>
            <Row>
              <Col className="mt-2">
                <EditorControls.StringInput {...rankProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...basisProps} />
              </Col>
            </Row>
          </Container>
        </HidableContainer>
      </DocumentBody>
      <Footer
        created={data.created_at}
        updated={data.updated_at}
        readOnly={!permissions.canChange}
        inspection={data.inspection}
        onChange={actions.onChange}
        id={id}
        headerProps={headerProps}
      />
    </EditorContainer>
  );
}

Editor.propTypes = {
  id: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

Editor.defaultProps = {
  onClose: null,
  onSave: null,
};

export default Editor;
